/**
 * A pillar's square category mark (DESIGN.md: 10px in the nav and tile
 * headers, 20px on sign-in). Identification only, never a state. Decorative
 * unless given a `label`.
 */
import clsx from 'clsx'
import type { Category } from './types'

export interface SwatchProps {
  category: Category
  size?: 10 | 16 | 20
  /** Accessible name when the swatch stands alone; omit when a label sits beside it. */
  label?: string
  className?: string
}

const FILL: Record<Category, string> = {
  baseline: 'bg-cat-baseline',
  bpa: 'bg-cat-bpa',
  identity: 'bg-cat-identity',
  secure: 'bg-cat-secure',
}

const SIZE: Record<NonNullable<SwatchProps['size']>, string> = {
  10: 'h-2.5 w-2.5',
  16: 'h-4 w-4',
  20: 'h-5 w-5',
}

export function Swatch({ category, size = 10, label, className }: SwatchProps) {
  return (
    <span
      {...(label ? { role: 'img', 'aria-label': label } : { 'aria-hidden': true })}
      className={clsx('inline-block flex-none', SIZE[size], FILL[category], className)}
    />
  )
}

export default Swatch
